import { Hidden } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { GuidedProcessSupportBlock } from '../../../../../global/components/guided-process-support-block';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../../global/components/layout/sidebar-content';
import { LockedPageMessage } from '../../../../../global/components/locked-page-message';
import { QuerySuccessMessage } from '../../../../../global/components/messages/query-success-message';
import { getGpsType } from '../../../../../global/helpers/gps-helper';
import { useLockedPageState } from '../../../../../global/hooks/useLockedPageState';
import { useParentRoute } from '../../../../../global/hooks/useParentRoute';
import { ApiStatuses } from '../../../../../global/models/api-model';
import { LockedPageKeys } from '../../../../../global/models/locked-page-model';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { FormTypes } from '../../../../account-info/models/form-models';
import { ArcRoutes } from '../../../constants/routes';
import { EmploymentState } from '../../employment/employment-model';
import { setDecreaseInScheduledHoursStatus, setUpdateScheduledHoursStatus } from '../../employment/employment-slice';
import { CompensationHistoryState } from '../compensation-history/compensation-history-model';
import { setUpdateCompensationStatus } from '../compensation-history/compensation-history-slice';
import { getCurrentScheduledPayment } from '../compensation-history/compensation-selectors';
import { CompensationInfo } from './compensation-info';
import { EmploymentInfo } from './employment-info';
import { ScheduledHoursInfo } from './scheduled-hours-info';

export function IndividualCompensation() {

	const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
	const compHistoryState = useSelector<TcsmStates, CompensationHistoryState>(state => state.compensationHistoryState);
	const dispatch = useDispatch();
	const parentRoute = useParentRoute();
	const gpsItem = getGpsType(null, null);

	const lockedState = useLockedPageState(LockedPageKeys.Compensation);

	useEffect(() => {
		dispatch(setUpdateCompensationStatus(ApiStatuses.None));
		dispatch(setUpdateScheduledHoursStatus(ApiStatuses.None));
		dispatch(setDecreaseInScheduledHoursStatus(ApiStatuses.None));

	}, []);

	const { epiContent } = epiProps?.compensationSettingsState;
	const currentScheduledPayment = getCurrentScheduledPayment(compHistoryState?.allScheduledPayments);


	const ScheduledHoursSupplementMessage = () => {
		return (<div dangerouslySetInnerHTML={{ __html: epiContent?.updatePositionSuggestionMessage }} />);
	};

	return (
		<>
			<LockedPageMessage lockedState={lockedState} />
			<PageHeader
				headerText={epiContent?.compensationTitle}
				description={epiContent?.compDescription} />
			<Hidden mdUp>
				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
				</SideBarContent>
			</Hidden>
			<DividerSection>
				<EmploymentInfo
					employmentData={employmentState?.currentEmployment}
				/>
				<Link to={`${parentRoute}${ArcRoutes.Employment}`}>{epiProps?.compensationSettingsState?.epiContent?.viewEmploymentText}</Link>
			</DividerSection>

			<DividerSection sectionText={epiContent?.currentScheduledHoursHeader}>
				<QuerySuccessMessage
					successfulAction={FormTypes.SCHEDULED_HOURS}
					supplement={<ScheduledHoursSupplementMessage />}
				/>
				<QuerySuccessMessage
					successfulAction={FormTypes.SCHEDULED_HOURS_BELOW_1000}
					supplement={<ScheduledHoursSupplementMessage />}
				/>
				<ScheduledHoursInfo
					employmentData={employmentState?.currentEmployment}
					disabled={lockedState.isLocked} />
			</DividerSection>

			<DividerSection removeDivider sectionText={epiContent?.currentCompensationHeader}>
				<QuerySuccessMessage successfulAction={FormTypes.COMPENSATION} />
				<CompensationInfo
					compensationData={currentScheduledPayment}
					disabled={lockedState.isLocked} />
			</DividerSection>
		</>
	);
}